"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var s = _interopRequireWildcard(require("./Pagination.style"));

var _SquareBorderButton = _interopRequireDefault(require("../Button/SquareBorderButton"));

var _DarkSquareBorderButton = _interopRequireDefault(require("../Button/DarkSquareBorderButton"));

var _default = function _default(_ref) {
  var label = _ref.label,
      current = _ref.current,
      _onClick = _ref.onClick,
      isDarkTheme = _ref.isDarkTheme;
  var isSelected = label === current;

  if (isDarkTheme) {
    return _react.default.createElement(_DarkSquareBorderButton.default, {
      onClick: function onClick() {
        return _onClick(label);
      },
      size: "medium",
      className: s.pageButton(),
      type: isSelected ? 'filled' : 'bordered'
    }, label + 1);
  }

  return _react.default.createElement(_SquareBorderButton.default, {
    onClick: function onClick() {
      return _onClick(label);
    },
    className: s.pageButton(),
    text: "".concat(label + 1),
    type: isSelected ? 'filled' : 'bordered'
  });
};

exports.default = _default;